import React from 'react';
// import robot from '../assets/images/robot.png';
import experience from '../assets/images/pngicons/Experience.jpg';
import products from '../assets/images/pngicons/Products.png';
import approach from '../assets/images/pngicons/Approach.png';
import pricing from '../assets/images/pngicons/Pricing.png';
import delivery from '../assets/images/pngicons/Delivery.png';
import support from '../assets/images/pngicons/Support.png';

export default function WhyChooseUs() {
  return (
    
<section className='why_choose_section dbl_heading_section'> 

<div className='container mt-5 mb-5'>

    <div className='row'>
        {/* <div className='col-12'> <div className='hdsub_title mt-3'>WHY SELECT US</div> </div> */}
        <div className='col-12 mb-2 text-center'> 
            <div className='hd_title'>Why Choose Us?</div>
            <p>We combine experience, innovative products, a customer-centric approach, competitive pricing, reliable delivery, and unmatched support to help you succeed. Here’s why you should partner with us:</p>

             </div>
    </div>

<div className='row mt-3'>

    <div className='col-lg-5'>

    <div className='d-flex mb-4'>  
            <div className='iconpic'><img src={experience} alt=''></img>  </div>     
            <div className='description'> 
                <h5>Experience</h5>
                <p>With years of experience in the travel and business solutions industry, our team has developed deep expertise across various sectors. We understand the complexities of the market, which enables us to offer practical and effective solutions that meet your needs. Our track record of successful projects and satisfied clients speaks to our ability to deliver results.</p>
            </div>
    </div>

    <div className='d-flex mb-4'>  
            <div className='iconpic'><img src={products} alt=''></img>  </div>     
            <div className='description'> 
                <h5>Products</h5>
                <p>We offer a wide range of innovative products and services designed to meet the diverse needs of businesses and consumers. Whether you're looking for travel management tools, GDS integrations, process automation systems, or corporate travel solutions, we have the right products to enhance your operations and drive growth. Our solutions are tailored to deliver high efficiency, cost-effectiveness, and scalability.</p>
            </div>
    </div>

    <div className='d-flex mb-4'>  
            <div className='iconpic'><img src={approach} alt=''></img>  </div>     
            <div className='description'> 
                <h5>Approach</h5>
                <p>Our approach is client-centric, focused on providing customized solutions that align with your unique business needs and objectives. We take the time to understand your challenges and goals, ensuring we offer solutions that not only solve problems but also add long-term value. Collaboration, transparency, and adaptability are key elements of our process, ensuring that you are always at the center of every decision.</p>
            </div>
    </div>

   
    </div>

    {/* <div className='col-lg-4 text-center d-md-block d-none'>
       <div><img src={robot} alt=''></img></div>
    </div> */}
<div className='col-lg-2'>

</div>

    <div className='col-lg-5'>

    <div className='d-flex mb-4'>  
            <div className='iconpic'><img src={pricing} alt=''></img>  </div>     
            <div className='description'> 
                <h5>Pricing</h5>
                <p>We believe in providing affordable and competitive pricing without compromising on quality. Our services are designed to deliver a high return on investment (ROI) by helping you reduce operational costs, increase efficiency, and optimize your business processes. Whether you are a small business or a large enterprise, our flexible pricing models cater to all budget sizes, ensuring you get the best value for your investment.</p>
            </div>
    </div>

    <div className='d-flex mb-4'>  
            <div className='iconpic'><img src={delivery} alt=''></img>  </div>     
            <div className='description'> 
                <h5>Delivery</h5>
                <p>We are committed to timely and reliable delivery. We understand the importance of meeting deadlines and providing solutions on time. Our efficient processes and streamlined workflows ensure that your projects are completed on schedule, without delays or disruptions. We pride ourselves on delivering high-quality services, even under tight timelines.</p>
            </div>
    </div>

    <div className='d-flex mb-4'>  
            <div className='iconpic'><img src={support} alt=''></img>  </div>     
            <div className='description'> 
                <h5>Support</h5>
                <p>Our exceptional support is one of the key reasons clients choose us. We offer 24/7 customer support to ensure that any issues are resolved quickly and effectively. Our team of experts is always available to provide assistance, whether it's for troubleshooting, ongoing optimization, or guidance. We are committed to being there for you whenever you need us, ensuring a smooth experience from start to finish.</p>
            </div>
    </div>

   
    </div>


</div>

</div>
</section>



  )
}
